class LogoScroll extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    /* eslint-disable-next-line no-undef */
    if (Shopify.designMode) return

    this.isTicking = false
    this.lastKnownY = window.scrollY

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)

    this.updateEl()
  }

  setupListeners () {
    super.setupListeners()

    this.onScroll = this.onScroll.bind(this)

    window.addEventListener('scroll', this.onScroll, { passive: true })
  }

  onScroll () {
    this.lastKnownY = window.scrollY

    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.scrollLogo()
  }

  scrollLogo () {
    const amountToMoveY = 100

    const scrollYAsAPercentage = this.lastKnownY / window.innerHeight

    let totalWindowsScrolled = 0
    for (let i = 0; i < scrollYAsAPercentage; i++) {
      totalWindowsScrolled = i
    }

    const singleWindowScrolledPercent =
      scrollYAsAPercentage - totalWindowsScrolled

    const transformAmountY = amountToMoveY * singleWindowScrolledPercent

    const logoEls = this.querySelectorAll('[data-logo-scroll-el="logo"]')

    logoEls.forEach((logoEl) => {
      logoEl.style.transform = `translate3d(0px, -${transformAmountY}%, 0px)`
    })
  }
}

if (!customElements.get('logo-scroll')) {
  customElements.define('logo-scroll', LogoScroll)
}
